import React, { useEffect, useRef } from 'react';
import s from './SettingsButton.scss';
import Icon from './icon.svg';
export const SettingsButton = ({ big, onClick, }) => {
    const ref = useRef(null);
    const iconSize = big ? 24 : 16;
    useEffect(() => {
        const button = ref.current;
        if (!button) {
            return;
        }
        // React onClick doesn't work because of:
        // https://github.com/wix/playable/blob/9bf6b3a793cab50a1e2ab166cf4bb550fb757957/src/modules/ui/bottom-block/bottom-block.view.ts#L99
        // So add click handler in such weird way
        button.addEventListener('click', onClick);
        return () => {
            button.removeEventListener('click', onClick);
        };
    }, [onClick]);
    return (React.createElement("button", { ref: ref, className: s.button, "data-hook": "wix-vod-playable-settings-button" },
        React.createElement(Icon, { height: iconSize, width: iconSize })));
};
export function createSettingsButtonContainer() {
    const element = document.createElement('div');
    element.className = s.root;
    element.setAttribute('data-hook', 'wix-vod-playable-settings-button-container');
    return {
        element,
    };
}
//# sourceMappingURL=SettingsButton.js.map